export const getBackendUrl = (route) => {
  const backendConfig = window.app.config.backendConfig
  const portPart = backendConfig.port ? `:${backendConfig.port}` : ''
  return `${backendConfig.protocol}://${backendConfig.host}${portPart}/${route}`
}
